
import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQ[] = [
    {
      question: 'Do you offer same-day service?',
      answer: 'When available, yes—we do our best to accommodate urgent requests. Call or text us for the fastest response, and we\'ll let you know our availability.'
    },
    {
      question: 'Is it safe for my surfaces?',
      answer: 'Absolutely. We choose the right cleaning method for each surface—whether it\'s high-pressure washing for concrete or soft washing for delicate materials like roofs and siding. Your property is in safe hands.'
    },
    {
      question: 'Do you use chemicals?',
      answer: 'We use eco-friendly cleaners when needed for tough stains, mold, or algae. All products are safe for your family, pets, and landscaping. We always pre-treat and rinse thoroughly.'
    },
    {
      question: 'What do you need for a quote?',
      answer: 'Just your address or service area, what you want cleaned, and optionally some photos. The more details you provide, the more accurate your quote will be. We typically respond within a few hours.'
    }
  ];

  return (
    <section id="faqs" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-lg text-blue-700">
            Everything you need to know about our services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-blue-200 rounded-xl overflow-hidden hover:border-cyan-300 transition-colors duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-cyan-50 transition-colors duration-300"
              >
                <span className="text-lg font-bold text-blue-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 bg-gradient-to-br from-cyan-400 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-white text-xl"></i>
                </div>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-blue-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-blue-700 mb-4">Still have questions?</p>
          <a
            href="tel:3052793585"
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-900 to-blue-800 text-white font-bold rounded-full hover:shadow-xl transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Us Now
          </a>
        </div>
      </div>
    </section>
  );
}
